import React, {useState, useRef, useEffect, memo} from 'react';
import * as ReactUtils from "../utils/ReactUtils.js";
import * as Utils from '../utils/Utils.js';
import * as HttpRequestUtils from '../utils/HttpRequestUtils';
import ImageActionBar from './components/ImageActionBar'; 

import rocketloadingImage from "../images/rocket.gif";

const EditImage = memo(function EditImage({ isUserSignedIn, isUserSubscribed, accessToken, loggedInUserId }) {
  const [isDragging, setIsDragging] = useState(false);
  const [editedImageUrl, setEditedImageUrl] = useState('');
  const fileInputRef = useRef(null); 
  //console.log("Edit Image", EditImage, isUserSignedIn, isUserSubscribed);

  useEffect(() => {
    if (isUserSignedIn) {
      if (!isUserSubscribed) {
          document.getElementById("editedImage_editAndUpdateImage").disabled = true;
          Utils.showHTMLElement(document.getElementById("editedImage_onlyAvailabletoPremium"));
      }
    }
  }, [isUserSignedIn, isUserSubscribed]);

  const handleEditImageButtonClick = async () => {
    if (!isUserSignedIn) {
      ReactUtils.showUserSignInOrOutPopup(null, document.getElementById("editedImage_editAndUpdateImage"), false,  Utils.reloadUI);
      return
    }

    const inputElement = document.getElementById('editedImage_file_input');
    if (!inputElement.files || inputElement.files.length === 0) {
      alert('Please upload an image file.');
      return;
    }

    if (!document.getElementById("editedImage_imageEditInputId").value) {
      alert('Please enter how to edit the image');
      return;
    }

    try {
      const $dimmer = document.getElementById('editedImage_loadingDimmer');
      Utils.showLoadingDimmer($dimmer);

      const resizedFile = await Utils.resizeImage(inputElement.files[0], 1024, 1024);
      const uploadImageResponse = await HttpRequestUtils.uploadFileToS3(loggedInUserId, resizedFile);
      if (uploadImageResponse[Utils.HTTP_ERROR] || !uploadImageResponse[Utils.HTTP_RESPONSE]) {
        alert('Upload Image Error: ' + uploadImageResponse[Utils.HTTP_ERROR]);
        return;
      }

      const editImageResponse =  await Utils.gptEditImageHttp(uploadImageResponse[Utils.HTTP_RESPONSE], 
          '', document.getElementById("editedImage_imageEditInputId").value, 
          document.getElementById("editedImage_sizeOfTheImageToCreateSectionId").value, accessToken);
      
      Utils.hideLoadingDimmer($dimmer);
      if (editImageResponse) {
        if (editImageResponse[Utils.HTTP_ERROR]) {
          alert('Edit Image failed:' + editImageResponse[Utils.HTTP_ERROR]);
          Utils.hideHTMLElement(document.getElementById("editedImage_imageActionsBar"));
        } else {
          document.getElementById("editedImage_editedImage").src = editImageResponse[Utils.HTTP_RESPONSE];
          setEditedImageUrl(editImageResponse[Utils.HTTP_RESPONSE]);
        }
      } else {
        alert("Edit image failed with empty response");
      }
      // const responseData = await response.json();
      // console.log(responseData); // Handle the edited image data
      // alert('Image edited successfully!');
    } catch (error) {
      console.error('Edit Image Error:', error);
      alert('Edit Image failed: ', error.message);
    }
  }

  const handleDragOver = (e) => {
    e.preventDefault();
    setIsDragging(true);
  };

  const handleDragLeave = () => {
    setIsDragging(false);
  };

  const handleDrop = (e) => {
    e.preventDefault();
    setIsDragging(false);
    const inputElement = document.getElementById('editedImage_file_input');
    inputElement.files = e.dataTransfer.files;
    handleFiles(e.dataTransfer.files);
  };

  const handleBrowseAndSelectFileButtonClick = () => {
    fileInputRef.current.click();
  };

  const handleFiles = async (files) => {
    if (files.length > 0) {
      // Get the first dropped file
      const file = files[0];
      // Check if the dropped file is an image
      if (file.type.startsWith('image/')) {
        // Read the dropped image file
        const reader = new FileReader();
  
        // When the file is read successfully
        reader.onload = function(event) {
          // Display the dropped image on the UI
          const imagePreview = document.getElementById('editedImage_imagePreview');
          imagePreview.src = event.target.result;
          imagePreview.style.display = 'block';
          Utils.hideHTMLElement(document.getElementById('noImageViewId'));
        };
  
        // Read the dropped file as a data URL (base64 encoded string)
        reader.readAsDataURL(file);
      } else {
        alert('Please drop an image file.');
      }
    }
  }

  return (
    <div>
      <button className="ui button basic purple" onClick={handleBrowseAndSelectFileButtonClick}>Browse and choose image</button>
      <div className="ui column stackable aligned grid" style={{margin: '12px 0 0 -14px'}}>
        <div onDragOver={handleDragOver} onDragLeave={handleDragLeave} onDrop={handleDrop} onClick={handleBrowseAndSelectFileButtonClick}>
            <img id="editedImage_imagePreview" src="" alt="Uploaded Image" className="ui rounded bordered image" 
              style={{ height: "250px"}} />
            <div id="noImageViewId" className={`drop-zone ${isDragging ? 'dragover' : ''}`} 
              style={{width: '600px', maxWidth:'50%', height: "200px"}}>
              <i className="upload cloud icon blue big"></i>
              <p style={{ marginTop: '10px', fontSize: '17px', color: 'gray'}}><b>Or Drag & Drop an image or click</b></p>
            </div>
            <input type="file" id="editedImage_file_input" ref={fileInputRef} className="file-input"
              accept={".bmp, .jpg, .png, .pbm, .webp"} // https://stackoverflow.com/questions/34390747/how-can-i-validate-for-only-csv-file-uploads-using-the-pattern-attribute-using-h
              onChange={(e) => handleFiles(e.target.files)}
            />
        </div>
      </div>

      <input type="text" id="editedImage_imageEditInputId" style={{minWidth: '300px', display: "inline", margin: '20px 16px 0px 0px'}} 
        placeholder="Enter how to edit image, e.g. remove text"/>
      <select id="editedImage_sizeOfTheImageToCreateSectionId" style={{display: "inline", margin: '20px 16px 0px 12px'}}>
        <option value="256x256">256x256</option>
        <option value="512x512" selected>512x512</option>
        <option value="1024x1024">1024x1024</option>
      </select>
      <div style={{marginTop: '20px'}}>
        <button id="editedImage_editAndUpdateImage" className="primary-button" onClick={handleEditImageButtonClick} 
            ><i className="edit outline icon"></i> Edit and update image
        </button>
        <div id="editedImage_onlyAvailabletoPremium" style={{marginTop: "5px", display: "none", color: "gray"}}>Upgrade and edit more images!</div>
      </div>

      <div id="editedImage_loadingDimmer" className="ui inverted dimmer">
          <div className="ui indeterminate text loader"></div>
          <img src={rocketloadingImage} style={{width: "24px", marginTop: "-12px"}} alt="rocket" />
      </div>

      {/* SECTION: Generated image */}
      <div className="ui divider"></div>
      <div className="medium-text" style={{color: "green", marginTop: "10px"}}>Edited Image</div>
      <img id="editedImage_editedImage" src="" className="ui rounded bordered image" alt="Edited Image" style={{marginTop: "10px", height: "350px"}} />
      { editedImageUrl && 
        <ImageActionBar imageUrl={editedImageUrl} redoImage={handleEditImageButtonClick}></ImageActionBar>
      }
    </div>
  )
})

export default EditImage;   